import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-9J6DHVFSPL";

export const initGA = () => {
  // Configuração inicial do Consent Mode (v2)
  // Deve ser chamado ANTES do initialize
  ReactGA.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });

  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const updateConsent = (granted: boolean) => {
  const value = granted ? "granted" : "denied";
  ReactGA.gtag("consent", "update", {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
  });
};

export const logPageView = (path?: string) => {
  ReactGA.send({ hitType: "pageview", page: path || window.location.pathname });
};

export const logEvent = (category: string, action: string, label?: string) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};
